import {FormProvider} from '@yandex-delivery/form'
import {OrderFormDesktop as OrderForm} from '@yandex-delivery/order-form'
import React from 'react'
import {Helmet} from 'react-helmet'
import {Footer, Header} from 'src/entities/desktop'
import {CreativeBlock} from 'src/shared/components/creative-block/CreativeBlock@desktop'
import {appConfig, experiments} from 'src/shared/config'
import {ExistingOrderDetector} from 'src/widgets/desktop'

import {AsyncDefaultValues} from '../AsyncDefaultValues/AsyncDefaultValues'
import * as classes from './HomePage.classes'
import {getDefaultValues} from './HomePage.hooks'
import {getPassportUrl, makeCanonicalUrl} from './lib'
import {FormSchema} from './schema/desktop'
import {seoConsts} from './seo-consts'

export function HomePage(): React.ReactElement {
  const {initialProps, origin} = appConfig
  const {zoneName, tariff} = initialProps
  const defaultValues = getDefaultValues()

  return (
    <>
      <Helmet>
        <title>{appConfig.seo?.title || seoConsts.title}</title>
        <meta
          content={appConfig.seo?.description || seoConsts.description}
          name="description"
        />
        <link
          href={makeCanonicalUrl(origin, zoneName, tariff)}
          rel="canonical"
        />
      </Helmet>
      {/* todo: Узнать у Таси про поведение хедера при оверскролле,
          если он должен оставаться на месте то использовать пропс isFixed у Header */}
      <Header />
      <main className={classes.content}>
        <FormProvider
          debug
          defaultValues={defaultValues}
          validationSchema={FormSchema}
        >
          <AsyncDefaultValues defaultValues={defaultValues} />
          <ExistingOrderDetector />
          <div className={classes.root}>
            <div className={classes.formWrapper}>
              <div className={classes.form} data-e2e="full-form">
                {experiments?.creativeBlock?.desktopImageSrc && (
                  <CreativeBlock creativeBlock={experiments.creativeBlock} />
                )}
                <OrderForm config={{...appConfig, getPassportUrl}} />
              </div>
            </div>
          </div>
        </FormProvider>
      </main>
      <Footer />
    </>
  )
}
